import React, { useState } from 'react';



import Icon from '../../../components/AppIcon';

const LeadTableRow = ({ lead, isSelected, onSelect, onStatusChange, onViewDetails, onClick, isBulkMode }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getStatusColor = (status) => {
    switch (status) {
      case 'new': return 'bg-blue-100 text-blue-800';
      case 'contacted': return 'bg-yellow-100 text-yellow-800';
      case 'qualified': return 'bg-green-100 text-green-800';
      case 'converted': return 'bg-emerald-100 text-emerald-800';
      case 'proposal': return 'bg-purple-100 text-purple-800';
      case 'negotiation': return 'bg-orange-100 text-orange-800';
      case 'closed-won': return 'bg-emerald-100 text-emerald-800';
      case 'closed-lost': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getScoreColor = (score) => {
    if (score >= 80) return 'text-green-600';
    if (score >= 60) return 'text-yellow-600';
    return 'text-red-600';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <tr
      className={`border-b border-border hover:bg-muted/50 transition-colors duration-200 cursor-pointer ${
        isSelected ? 'bg-blue-50/50' : ''
      }`}
    >
      <td className="px-4 py-4" onClick={(e) => e?.stopPropagation()}>
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onSelect}
          className="rounded border-border cursor-pointer"
        />
      </td>
      <td className="px-4 py-4" onClick={onClick}>
        <div className="flex items-center space-x-3">
          <div className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
            <span className="text-sm font-semibold text-primary">
              {lead?.name?.charAt(0)?.toUpperCase() || '?'}
            </span>
          </div>
          <div>
            <p className="font-medium text-foreground text-sm">{lead?.name}</p>
            <p className="text-xs text-muted-foreground">{lead?.email}</p>
          </div>
        </div>
      </td>
      <td className="px-4 py-4 hidden md:table-cell" onClick={onClick}>
        <div>
          <p className="font-medium text-foreground text-sm">{lead?.company || '—'}</p>
          <p className="text-xs text-muted-foreground">{lead?.title || '—'}</p>
        </div>
      </td>
      <td className="px-4 py-4" onClick={onClick}>
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
          getStatusColor(lead?.status)
        }`}>
          {lead?.status?.charAt(0)?.toUpperCase() + lead?.status?.slice(1)?.replace('-', ' ')}
        </span>
      </td>
      <td className="px-4 py-4 hidden md:table-cell" onClick={onClick}>
        <div className="flex items-center space-x-2">
          <span className={`font-semibold text-sm ${getScoreColor(lead?.score)}`}>
            {lead?.score}
          </span>
          <div className="w-14 bg-gray-200 rounded-full h-1.5">
            <div
              className={`h-1.5 rounded-full ${
                lead?.score >= 80 ? 'bg-green-500' :
                lead?.score >= 60 ? 'bg-yellow-500' : 'bg-red-500'
              }`}
              style={{ width: `${lead?.score}%` }}
            />
          </div>
        </div>
      </td>
      <td className="px-4 py-4 hidden lg:table-cell" onClick={onClick}>
        <span className="text-sm text-muted-foreground">
          {lead?.assignee?.name || 'Unassigned'}
        </span>
      </td>
      <td className="px-4 py-4 hidden lg:table-cell" onClick={onClick}>
        <span className="text-sm text-muted-foreground">
          {formatDate(lead?.lastInteraction)}
        </span>
      </td>
      <td className="px-4 py-4" onClick={(e) => e?.stopPropagation()}>
        <div className="flex items-center space-x-1">
          <button
            onClick={() => onViewDetails?.(lead)}
            className="p-1.5 hover:bg-muted rounded-md transition-colors"
            title="View Details"
          >
            <Icon name="Eye" size={15} className="text-muted-foreground" />
          </button>
          <button
            className="p-1.5 hover:bg-muted rounded-md transition-colors"
            title="Send Message"
          >
            <Icon name="MessageSquare" size={15} className="text-muted-foreground" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default LeadTableRow;